export default __webpack_public_path__ + "static/media/pic_5_mob.325d2cf7.webp";